import { FormGroupState } from "ngrx-forms";
import { InvestmentItemModel } from "src/app/model/investment-item.model";

export interface IInvestmentsState {
    form: FormGroupState<InvestmentsModel>;
    dataSaved:boolean;
    isManualSplit:boolean;
    investmentOptions: InvestmentItemModel[];
}

export class InvestmentsModel{
    investments: InvestmentItemModel[];
}